import { querySelector } from '@wix/thunderbolt-dom-utils'
import type { CellIndexMapType, CellsMapType, IdIndexMapType } from './index'

type OffsetTopMapType = Record<number, Array<HTMLElement>>

const createOffsetTopMap = (items: Array<string>, repeater: HTMLElement) => {
	const offsetTopMap: OffsetTopMapType = {}

	items.forEach((itemId) => {
		// Use thunderbolt-dom-utils querySelector with automatic ID-to-class fallback
		const cell = querySelector(`[id$="${itemId}"]`, { element: repeater }) as HTMLElement | null
		if (!cell) {
			return
		}
		if (!offsetTopMap[cell.offsetTop]) {
			offsetTopMap[cell.offsetTop] = []
		}
		offsetTopMap[cell.offsetTop].push(cell)
	})

	return offsetTopMap
}

const createCellMap = (offsetTopMap: OffsetTopMapType) => {
	const cellsMap: CellsMapType = []

	Object.keys(offsetTopMap)
		.map((key) => Number(key))
		.sort((a, b) => (a < b ? -1 : 1))
		.forEach((offsetTop, index) => {
			cellsMap[index] = offsetTopMap[offsetTop]
		})

	cellsMap.forEach((row) => {
		row.sort((a, b) => (a.offsetLeft < b.offsetLeft ? -1 : 1))
	})

	return cellsMap
}

const createIndexMap = (cellsMap: CellsMapType) => {
	const idIndexMap: IdIndexMapType = {}
	const cellIndexMap: CellIndexMapType = new Map()

	cellsMap.forEach((cellRow, rowIndex) => {
		cellRow.forEach((cell, columnIndex) => {
			idIndexMap[cell.id] = { row: rowIndex, column: columnIndex }
			cellIndexMap.set(cell, { row: rowIndex, column: columnIndex })
		})
	})

	return { idIndexMap, cellIndexMap }
}

export const getRepeaterCells = (items: Array<string>, repeater: HTMLElement) => {
	const offsetTopMap = createOffsetTopMap(items, repeater)
	const cellsMap = createCellMap(offsetTopMap)
	const { idIndexMap, cellIndexMap } = createIndexMap(cellsMap)

	return { cellsMap, idIndexMap, cellIndexMap }
}
